
import s from './client_assets/state'
import * as a from './client_assets/actions'
import * as m from './client_assets/mutations'
import * as g from './client_assets/getters'

export const state = s
export const actions = {...a}
export const mutations = {...m}
export const getters = {...g}
